module.exports = __webpack_public_path__ + "a2bd380be6baed459a979feb2cd16ac2.MP3";